import { ConfirmDialogIdentifier } from 'legacy/lut/components/shared/Confirm/actions'

export const QBR_DOCUMENT_SAVE_CONFIRM_IDENTIFIER: ConfirmDialogIdentifier =
  'QbrDocumentSaveConfirm'
